//API
import { getRequest, postRequest } from "../globalService"

const endPoint = 'auth';


export const getMe = ()=> {
    return getRequest(`${endPoint}/me`, true);
}


export const authWithEmail = (data)=> {
    return postRequest(`${endPoint}/user`,data, false);
}

export const verifyEmail = (data)=> {
    return postRequest(`${endPoint}/verifyemail`,data, false);
}

export const authWithGoogle = (data)=> {
    return postRequest(`${endPoint}/user/google`,data, false);
}

export const registerWithEmail = (data)=> {
    return postRequest(`${endPoint}/register`,data, false);
}

export const registerWithGoogle = (data)=> {
    return postRequest(`${endPoint}/register/google`,data, false);
}

export const verifyToken = (token)=> {
    return getRequest(`${endPoint}/validate/${token}`,false)
}
